export const SET_ID = 'SET_ID';
export const SET_COMPANY_NAME = 'SET_COMPANY_NAME';
export const SET_COMPANY_INFO = 'SET_COMPANY_INFO';
